import type { SupplyChainPlan } from '../types/supplyChain';
import type { SiteRagReport } from '../types/siteRag';

export type SupplyChainPlanSource = 'override' | 'site' | 'report-at-gen' | 'none';

export interface ResolvedSupplyChainPlan {
  plan: SupplyChainPlan | null;
  source: SupplyChainPlanSource;
}

type SupplyChainReportOverrides = Pick<SiteRagReport, 'supplyChainPlanOverride' | 'supplyChainPlanAtGen'>;

/**
 * Resolve supply-chain plan precedence for report generation and display.
 *
 * Order:
 *  1) report.supplyChainPlanOverride (merged over site plan)
 *  2) site.supplyChainPlan
 *  3) report.supplyChainPlanAtGen (legacy backfill / replay)
 */
export function resolveSupplyChainPlan(
  sitePlan: SupplyChainPlan | null | undefined,
  report?: SupplyChainReportOverrides,
): ResolvedSupplyChainPlan {
  if (report?.supplyChainPlanOverride && sitePlan) {
    return {
      plan: {
        ...sitePlan,
        ...report.supplyChainPlanOverride,
      },
      source: 'override',
    };
  }
  if (sitePlan) {
    return { plan: sitePlan, source: 'site' };
  }
  if (report?.supplyChainPlanAtGen) {
    return { plan: report.supplyChainPlanAtGen, source: 'report-at-gen' };
  }
  return { plan: null, source: 'none' };
}
